export default [
  {
    path: '/estrutura/inativa',
    name: 'Estruturas Inativas',
    component: () => import(/* webpackChunkName: "estrutura-inativa" */ './Lista.vue')
  }, {
    path: '/estrutura/inativar',
    name: 'Inativar Estrutura',
    component: () => import(/* webpackChunkName: "estrutura-inativa" */ './Inativar.vue')
  }
]
